import React from 'react';

import StocktakesModule from '../stocktakes/components/StocktakesModule';
import InventoryPermissionGuard from './InventoryPermissionGuard';

export default function InventoryStocktakesModule() {
  return (
    <InventoryPermissionGuard
      permissions={[
        { resource: 'inventory.stocktake', action: 'read' },
      ]}
    >
      <StocktakesModule />
    </InventoryPermissionGuard>
  );
}